import {
  VALIDATE_AUTH_REQUESTS,
  VALIDATE_AUTH_SUCCESS,
  VALIDATE_AUTH_FAILURE,
} from "../actions/actionTypes";
import apiClient from "../../utils/apiClient";

export const verifyThunk = (idNumber, verificationMethod, captchaValue, resend) => {
  return async (dispatch) => {
    dispatch({ type: VALIDATE_AUTH_REQUESTS });
    let errorData = "";

    try {
      const response = await apiClient.post("/verify", {
        idNumber,
        verificationMethod,
        captchaValue,
        resend,
      });

      const data = response.data;
       
    

      dispatch({ type: VALIDATE_AUTH_SUCCESS, payload: data });

    } catch (error) {
      errorData = error.response?.data || errorData;
      dispatch({
        type: VALIDATE_AUTH_FAILURE,
        payload:
          errorData || "Verification failed. Please try again later.",     
      });

    }
  };
};
